<div class="body">

    <div class="spacer"></div>

    <div class="a4-page">

        <div class="a4-page-inner" [ngStyle]="{'margin-left': pageMargin.left + 'cm', 'margin-right': pageMargin.right + 'cm'}">

            <div class="text" [innerHTML]="preText"></div>

            <div class="editable-text quill-wrapper quill-wrapper-white-toolbar quill-wrapper-graduated-bg">

                <ng-container *ngIf="editable; else readOnly">

                    <quill-editor class="quill" theme="snow" format="html" [formControl]="noteControl"></quill-editor>
            
                </ng-container>
            
                <ng-template #readOnly>
            
                    <quill-view-html class="quill quill-readonly" theme="snow" format="html" [content]="noteControl.value? noteControl.value: ''"></quill-view-html>
            
                </ng-template>

            </div>

            <div class="text" [innerHTML]="afterText"></div>

        </div>

    </div>

    <div class="spacer"></div>

</div>